import { render, staticRenderFns } from "./outlines.vue?vue&type=template&id=28c40e20&scoped=true&"
import script from "./outlines.vue?vue&type=script&lang=js&"
export * from "./outlines.vue?vue&type=script&lang=js&"
import style0 from "./outlines.vue?vue&type=style&index=0&id=28c40e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c40e20",
  null
  
)

export default component.exports